// @flow
import {CATEGORY} from 'constants/actions';

/**
 * Get status apply filters
 *
 * @param {object} state  - Current state
 * @param {object} action - Received action
 * @returns {boolean} - status filter
 */
export default function applyFilter(
    state: boolean = false,
    action: {type: string, state: boolean},
): boolean {
    switch (action.type) {
        case CATEGORY.GET_APPLY_FILTER:
            return action.state;
        default:
            return state;
    }
}
